import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { axios, APIBASE_REVIVERAPPLICATION } from "./ApiConfig";
import { ManualMatchRequest, WeightReportLinePage, WeightReportListItem, WeightReportUploadRequest } from "@/types";

const getWeightReportLines = async (
  page: number | null,
  size: number | null,
  senderCompanyId: number | null,
  weightReportImportId: number | null
) => {
  return axios.get<WeightReportLinePage>(`${APIBASE_REVIVERAPPLICATION}api/weightreport/importlines`, {
    params: {
      page,
      size,
      senderCompanyId,
      weightReportImportId,
    },
  });
};

export const useGetWeightReportLines = (
  page: number | null,
  size: number | null,
  senderCompanyId: number | null,
  weightReportImportId: number | null,
  options?: Partial<UseQueryOptions<WeightReportLinePage>>
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<WeightReportLinePage>({
    queryKey: ["weightReportLines", page, size, senderCompanyId, weightReportImportId],
    queryFn: async () => {
      const result = await getWeightReportLines(page, size, senderCompanyId, weightReportImportId);
      return result.data;
    },
    ...queryOptions,
  });
};

const getWeightReportDetails = async (weightReportImportId: number) => {
  return axios.get<WeightReportListItem>(`${APIBASE_REVIVERAPPLICATION}api/weightreport/list/${weightReportImportId}`);
};

export const useWeightReportDetails = (
  weightReportImportId: number,
  options?: Partial<UseQueryOptions<WeightReportListItem>>
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<WeightReportListItem>({
    queryKey: ["weightReportDetails", weightReportImportId],
    queryFn: async () => {
      const result = await getWeightReportDetails(weightReportImportId);
      return result.data;
    },
    ...queryOptions,
  });
};

export const postMatchWeightReport = async (manualMatchRequest: ManualMatchRequest) => {
  return axios.post(`${APIBASE_REVIVERAPPLICATION}api/weightreport/doManualMatch`, manualMatchRequest);
};

export const uploadWeightReport = async (req: WeightReportUploadRequest) => {
  return axios.post<number>(`${APIBASE_REVIVERAPPLICATION}api/weightreport/doUpload`, req);
};
